import { render, staticRenderFns } from "./PatientSidebar.vue?vue&type=template&id=4fa18b90&scoped=true"
import script from "./PatientSidebar.vue?vue&type=script&lang=js"
export * from "./PatientSidebar.vue?vue&type=script&lang=js"
import style0 from "./PatientSidebar.vue?vue&type=style&index=0&id=4fa18b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa18b90",
  null
  
)

export default component.exports